export interface BrandMilestone {
  year: string;
  title: string;
  description: string;
}

export interface Testimonial {
  id: string;
  name: string;
  location: string;
  avatar: string;
  rating: number;
  content: string;
  productName: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const brandInfo = {
  name: '瓜瓜基地',
  fullName: '瓜瓜基地瓜果直采平台',
  slogan: '正宗瓜果直采，新鲜到家',
  description: '瓜瓜基地成立于2018年，是一家专注于优质瓜果产地直采的电商平台。我们致力于打通从产地到消费者的最短路径，让每一位顾客都能以实惠的价格享受到最新鲜、最正宗的时令瓜果。我们与全国20多个优质瓜果产区的300多户果农建立了长期合作关系，坚持"不熟不采、不好不发"的品质理念，将最甜美的瓜果送到千家万户。',
  phone: '400-888-6666',
  email: 'service@guaguabase.com',
  address: '北京市朝阳区农展馆南路12号瓜瓜大厦',
  workingHours: '周一至周日 9:00 - 21:00',
  wechat: 'guaguajidi',
};

export const milestones: BrandMilestone[] = [
  {
    year: '2018',
    title: '瓜瓜基地成立',
    description: '三位热爱农业的年轻人创立瓜瓜基地，立志让优质瓜果从产地直达消费者餐桌。',
  },
  {
    year: '2019',
    title: '建立首个直采基地',
    description: '在山东潍坊建立首个西瓜直采基地，与50户果农达成合作协议，开启产地直发模式。',
  },
  {
    year: '2020',
    title: '拓展全国产区',
    description: '新增新疆哈密、甘肃敦煌、浙江嘉兴等优质瓜果产区，合作果农突破200户。',
  },
  {
    year: '2021',
    title: '获千万级融资',
    description: '获得知名投资机构千万级天使轮融资，加速供应链建设和品牌推广。',
  },
  {
    year: '2022',
    title: '会员突破50万',
    description: '凭借优质的产品和服务，平台注册会员突破50万，复购率达65%，成为行业标杆。',
  },
  {
    year: '2023',
    title: '冷链物流升级',
    description: '与顺丰冷链达成战略合作，实现全国主要城市次日达，进一步保证瓜果新鲜度。',
  },
  {
    year: '2024',
    title: '品质认证体系',
    description: '建立自有品质认证体系"瓜瓜优选"，引入第三方检测，为每一颗瓜的品质保驾护航。',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't-001',
    name: '李女士',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20woman%20portrait%20in%20her%2030s%2C%20warm%20smile%2C%20professional%20studio%20headshot%20on%20a%20light%20cream%20background%2C%20simple%20elegant%20style&width=200&height=200&seq=avatar-t-001&orientation=squarish',
    rating: 5,
    content: '已经是第三次在瓜瓜基地买西瓜了！麒麟西瓜真的超级甜，皮薄肉多，家人都说比超市买的好吃太多。物流也很快，下单第二天就到了，包装也很用心，西瓜完好无损。以后买瓜就认准瓜瓜基地了！',
    productName: '麒麟西瓜',
  },
  {
    id: 't-002',
    name: '王先生',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20man%20portrait%20in%20his%2040s%2C%20friendly%20smile%2C%20studio%20headshot%20on%20a%20light%20cream%20background%2C%20clean%20professional%20style&width=200&height=200&seq=avatar-t-002&orientation=squarish',
    rating: 5,
    content: '买的西州蜜哈密瓜，真的惊艳到我了！切开那一刻整个房间都是蜜瓜的香气，口感软糯香甜，和在新疆当地吃的一模一样。给父母也买了一份，他们都说好。品质真的没话说，推荐给身边所有朋友了。',
    productName: '西州蜜哈密瓜',
  },
  {
    id: 't-003',
    name: '张女士',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=A%20smiling%20Chinese%20woman%20portrait%20in%20her%2020s%2C%20natural%20light%20studio%20headshot%20on%20a%20light%20cream%20background%2C%20fresh%20youthful%20style&width=200&height=200&seq=avatar-t-003&orientation=squarish',
    rating: 5,
    content: '绿宝石香瓜太好吃了！脆脆甜甜的，香气特别浓郁，同事闻到香味都跑来问在哪买的。价格也很公道，比水果店便宜不少。已经安利给整个办公室了，大家一起团购更划算！',
    productName: '绿宝石香瓜',
  },
  {
    id: 't-004',
    name: '刘先生',
    location: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20Chinese%20man%20portrait%20in%20his%2030s%2C%20warm%20smile%2C%20studio%20headshot%20on%20a%20light%20cream%20background%2C%20relaxed%20casual%20style&width=200&height=200&seq=avatar-t-004&orientation=squarish',
    rating: 4,
    content: '团购了十箱麒麟西瓜给公司做下午茶福利，同事们都说好吃。每个瓜的大小都很均匀，甜度也够。就是希望能多上一些新品种，比如最近很火的羊角蜜之类的，会更丰富。',
    productName: '麒麟西瓜（团购）',
  },
  {
    id: 't-005',
    name: '陈女士',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cheerful%20Chinese%20woman%20portrait%20in%20her%2030s%2C%20bright%20smile%2C%20studio%20headshot%20on%20a%20light%20cream%20background%2C%20warm%20friendly%20style&width=200&height=200&seq=avatar-t-005&orientation=squarish',
    rating: 5,
    content: '第一次尝试网购瓜果，本来还有点担心，结果完全超出预期！收到的时候包装特别精致，每个瓜都用泡沫网套保护得很好。金黄哈密瓜切开的时候汁水都溢出来了，甜度爆表！以后水果就在瓜瓜基地买了。',
    productName: '金黄哈密瓜',
  },
];

export const faqs: FaqItem[] = [
  {
    question: '瓜瓜基地的瓜果是从哪里发货的？',
    answer: '我们的瓜果全部从产地直发。比如哈密瓜从新疆哈密和甘肃敦煌产区直发，西瓜从山东潍坊和广西南宁产区直发，香瓜从浙江嘉兴和河北保定产区直发，确保从采摘到送达不超过48小时。',
  },
  {
    question: '如何保证瓜果的新鲜度和品质？',
    answer: '我们建立了严格的"瓜瓜优选"品质认证体系：第一步，只与拥有10年以上种植经验的老农户合作；第二步，采摘前使用专业仪器检测甜度和成熟度；第三步，当天采摘当天发货；第四步，与顺丰冷链合作，全程温控运输。每一颗瓜都经过层层筛选，确保品质。',
  },
  {
    question: '下单后多久能收到？',
    answer: '全国主要城市（一线及省会城市）下单后次日可达，其他城市2-3天内送达。我们与顺丰冷链合作，确保运输过程中的温度控制，让瓜果保持最佳新鲜状态到达您手中。',
  },
  {
    question: '如果收到的瓜果有质量问题怎么办？',
    answer: '我们提供"坏果包赔"服务。如果您收到的瓜果有任何质量问题（如腐烂、破损、不熟等），请在签收后24小时内联系客服，拍照上传，我们核实后会第一时间为您补发或退款。客服热线：400-888-6666。',
  },
  {
    question: '是否支持企业团购？',
    answer: '当然支持！我们为企业和团体客户提供定制化的团购方案，包括企业下午茶福利、节日礼品、客户答谢等场景。团购订单享受专属折扣和定制包装服务。请致电400-888-6666或联系在线客服了解更多团购优惠政策。',
  },
  {
    question: '瓜果的季节性怎么办？买不到喜欢的品种？',
    answer: '我们根据季节变化动态调整产品线，确保每个季节都有最新鲜的时令瓜果供您选择。夏季以西瓜、哈密瓜、香瓜为主，其他季节会上架芒果、水蜜桃、猕猴桃等时令水果。关注瓜瓜基地，一年四季都有新鲜水果可以享用！',
  },
];